<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>警戒线设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>

      <div style="rgb(222,222,222);width: 100%;height: 600px;">
<!--        <el-button size="mini" @click="createShopAlertLine">门店配置警戒线</el-button>-->
<!--        <br>-->
        <span style="font-size: 14px;color: #8c939d">新建警戒线：</span>
        <el-card>
          <el-select v-model="shopAlertLine.alertLineTypeName" size="mini" placeholder="请选择类目" clearable
                     @change="selectAlertLine">
            <el-option
              v-for="item in alertLineTypes"
              :key="item.id"
              :label="item.value"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input-number v-model="shopAlertLine.alertLineValue" controls-position="right" size="mini"
                           :precision="2" :step="0.01"
                           :min="0.01" :max="100"></el-input-number>
          <el-button size="mini" @click="createShopAlertLine">确 定</el-button>
        </el-card>
        <span style="font-size: 14px;color: #8c939d">警戒线列表：</span>
        <el-table height="550px" :data="alertLines" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            label="操作"
            align="center"
            width="100">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-evenly">
                <el-link type="primary" icon="el-icon-edit"
                         @click="toEditPage(scope.row)"></el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="alertLineTypeName"
            label="类目"
            align="center">
          </el-table-column>
          <el-table-column
            prop="alertLineValue"
            label="值"
            align="center">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="编辑警戒线"
      :visible.sync="editDialog"
      width="40%"
      style="position: absolute"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <p>类目：</p>
      <el-input v-model="editAlertLine.alertLineTypeName" readonly
                size="mini" style="width: 200px;"></el-input>
      <p>值：</p>
      <el-input-number v-model="editAlertLine.alertLineValue" controls-position="right" size="mini"
                       :precision="2" :step="0.01"
                       :min="0.01" :max="100"></el-input-number>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeDialog">取 消</el-button>
            <el-button size="mini" @click="editAlertLineMethod">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      alertLines:[],
      alertLineTypes:[
        {id:1, value:'消费单退费'},
        {id:2, value:'支付银行手续费'},
        {id:3, value:'货款'},
        {id:4, value:'营业支出'},
        {id:5, value:'绩效工资'},
        {id:6, value:'福利成本'},
        {id:7, value:'支付广告费'},
        {id:8, value:'门店保险'},
        {id:9, value:'支付培训费'},
        {id:10, value:'门店房租'},
        {id:11, value:'门店其他支出'},
        {id:12, value:'门店其他收入'},
        {id:13, value:'净利润'},
        {id:14, value:'会员消费预警'}
      ],
      shopAlertLine:{
        shopIds:[],
        creator:'',
        alertLineTypeName:'',
        alertLineValue:'',
      },
      editDialog:false,
      editAlertLine:''
    }
  },
  methods:{
    toEditPage(row){
      this.editAlertLine = row;
      this.editDialog = true;
    },
    closeDialog(){
      this.editDialog = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.loadShopAlertLines(data.id);
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    selectAlertLine(data){
      this.shopAlertLine.alertLineTypeName = data;
    },
    async createShopAlertLine(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.shopAlertLine.shopIds = this.$refs.tree.getCheckedKeys();
      if (this.shopAlertLine.shopIds.length == 0){
       this.$message.warning("请选择机构！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }

      this.shopAlertLine.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/shop/alert/line`, this.shopAlertLine);
      if (res.code === 200){
        this.$message.success("操作成功！");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }

      this.shopAlertLine.alertLineTypeName = '';
      this.shopAlertLine.alertLineValue = '';
      await this.loadShopAlertLines(this.shopAlertLine.shopIds[0]);
    },
    async loadShopAlertLines(data){
      const {data:res} = await this.$http.get(`/load/shop/alert/line/${data}`);
      this.alertLines = res.data;
    },
    async editAlertLineMethod(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      this.editAlertLine.creator = this.userId;
      this.editAlertLine.shopIds = this.$refs.tree.getCheckedKeys();
      const {data:res} = await this.$http.post(`/edit/shop/alert/line`, this.editAlertLine);
      if(res.code == 200){
        this.$message.success("操作成功！");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
      this.closeDialog();
      await this.loadShopAlertLines(this.editAlertLine.shopId);
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AlertLine.vue